// extracted by mini-css-extract-plugin
export default {"root":"EditCampaign_root__vXtz1","tabs":"EditCampaign_tabs__jg6rh","tab":"EditCampaign_tab__-EKYP"};